import ReservationTimeType from "./ReservationTimeType";

class ReservationTimeTypeClass {
  public static of(value: any): ReservationTimeType {
    switch (value) {
      default:
      case ReservationTimeType.MINUTE_15:
        return ReservationTimeType.MINUTE_15;
      case ReservationTimeType.MINUTE_30:
        return ReservationTimeType.MINUTE_30;
      case ReservationTimeType.MINUTE_60:
        return ReservationTimeType.MINUTE_60;
      case ReservationTimeType.MINUTE_90:
        return ReservationTimeType.MINUTE_90;
      case ReservationTimeType.MINUTE_120:
        return ReservationTimeType.MINUTE_120;
    }
  }

  constructor(private readonly _value: ReservationTimeType = ReservationTimeType.MINUTE_30) {
  }

  public toNumber(): number {
    switch (this._value) {
      default:
      case ReservationTimeType.MINUTE_30:
        return 30;
      case ReservationTimeType.MINUTE_15:
        return 15;
      case ReservationTimeType.MINUTE_60:
        return 60;
      case ReservationTimeType.MINUTE_90:
        return 90;
      case ReservationTimeType.MINUTE_120:
        return 120;
    }
  }

  get value() {
    return this._value;
  }
}

export default ReservationTimeTypeClass;
